<template>
    <div class="mb-4">
        <div id="select-layers" class="">
            <v-autocomplete
                aria-label="add layers"
                id="add-layers"
                v-model='selectedValues'
                :label="t_layers"
                :items="fullLayerList.data"
                multiple
                outlined
                dense
                clearable
                hide-details="auto">
            </v-autocomplete>
        </div>
    </div>
</template>

<script>
    import toaster from "../../../common/toaster";

    export default {
        props: ['currentLayers', 'allLayers'],
        data: function () {
            return {
                t_layers: Lang.langGet("Add layers to media"),
                t_load_failed: Lang.langGet("Failed to load layers from database."),
                fullLayerList: {data: this.allLayers},
                selectedValues: this.currentLayers,
            }
        },
        watch: {
            selectedValues: function (val, oldVal) {
                this.$emit('currentLayersUpdated', val);
            }
        },
        methods: {
            loadLayers: function () {
                if (this.fullLayerList.data.length > 0) {
                    return;
                }

                axios.post('/content/mediapool/loadlayers', {
                    id: Laravel.activeProject
                }).then((response) => {
                    this.fullLayerList.data = response.data.data;
                    this.$emit('allLayersUpdated', this.fullLayerList.data);
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_failed);
                });
            }
        },
        mounted() {
            this.loadLayers();
        }
    }
</script>
